import { useEffect } from 'react'

import { useToggle } from './'

export const useClickOutside = (ref) => {
  const { isOpen, toggle } = useToggle()

  useEffect(() => {
    const onClickOutside = (e) => {
      if (!ref) return

      const current = ref.current
      if (isOpen && current && !current.contains(e.target)) {
        toggle()
      }
    }

    const onKeyDown = ({ key }) => {
      if (isOpen && key === 'Escape') {
        toggle()
      }
    }

    document.addEventListener('mousedown', onClickOutside)
    document.addEventListener('keydown', onKeyDown)

    return () => {
      document.removeEventListener('mousedown', onClickOutside)
      document.removeEventListener('keydown', onKeyDown)
    }
  }, [ref, isOpen])

  return { isOpen, toggle }
}
